import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import ContactsIcon from '@material-ui/icons/Contacts';
import { getTokenLogout, removeTokenInLocalStorage } from 'src/actions/getTokenActions';
import { useDispatch } from 'react-redux';
import {
  Avatar,
  Box,
  Button,
  ListItem,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from '@material-ui/core';
import {
  BarChart2 as BarChartIcon,
  List as ListIcon,
  User as UserIcon,
  Server as ServerIcon,
  FileText as FileTextIcon,
  Activity,
  LogOut,
  Columns,
  Grid
} from 'react-feather';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import getInitials from 'src/utils/getInitials';
import NavItem from './NavItem';
import { useSelector } from 'react-redux';



const items = [
  {
    href: '/app/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  {
    href: '/app/products',
    icon: ListIcon,
    title: 'Auswertungen'
  },
  {
    href: '/app/rackrows',
    icon: Columns,
    title: 'Rackreihen'
  },
  {
    href: '/app/racks',
    icon: Grid,
    title: 'Racks'
  },
  {
    href: '/app/phasen',
    icon: Activity,
    title: 'Phasen'
  },
  {
    href: '/app/rechnung',
    icon: FileTextIcon,
    title: 'Abrechnung' 
  },
  /*{
    href: '/app/agents',
    icon: SlidersIcon,
    title: 'Agents Steuerung'
  },*/
  {
    href: '/app/account',
    icon: UserIcon,
    title: 'Account'
  },
  {
    href: '/app/devices',
    icon: ServerIcon,
    title: 'Geräte'
  },

  // {
  //   href: '/login',
  //   icon: LockIcon,
  //   title: 'Login'
  // },
  // {
  //   href: '/register',
  //   icon: UserPlusIcon,
  //   title: 'Register'
  // },
  // {
  //   href: '/404',
  //   icon: AlertCircleIcon,
  //   title: 'Error'
  // }
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const firstName = useSelector(state => state.authReducer.firstName );
  const lastName = useSelector(state => state.authReducer.lastName );
  const jobTitle = useSelector(state => state.authReducer.description );
  const roles = useSelector(state => state.authReducer.roles);
  const dispatch = useDispatch()

  let itemsForRender
  if(!roles.includes("Administrator")) {
    itemsForRender = items.filter(item => (item.title !== 'Benutzer'))
  } else {
    itemsForRender = items
  } 

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2
        }}
      >
        <Avatar
          component={RouterLink}
          src=''
          sx={{
            cursor: 'pointer',
            width: 64,
            height: 64
          }}
          to="/app/account"
          style={{ color: '#f50057' }}
        >
          {getInitials(`${firstName} ${lastName}`)}
        </Avatar>
        <Typography
          color="textPrimary"
          variant="h5"
        >
          {`${firstName} ${lastName}`}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {jobTitle}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {itemsForRender.map((item) => ( 
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          )
         )}
     <ListItem disablePadding sx={{ display: 'flex', py: 0}}>
     <Button sx={{
          color: 'text.secondary',
          fontWeight: 'medium',
          justifyContent: 'flex-start',
          letterSpacing: 0,
          py: 1.25,
          textTransform: 'none',
          width: '100%',
          '& svg': {
            mr: 1
          }
        }}
        onClick={() => removeTokenInLocalStorage(false, dispatch)}
        >
          
            <LogOut/>
          
        <span>
          Log Out
        </span>
     </Button>
     </ListItem>
        </List>
      </Box>
      {/* <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          backgroundColor: 'background.default',
          m: 2,
          p: 2
        }}
      >
        <Typography
          align="center"
          gutterBottom
          variant="h5"
        >
          Do you need help?
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2
          }}
        >
          <Button
            color="primary"
            component="a"
            href="https://react-material-kit.devias.io"
            variant="contained"
          >
            IT Support
          </Button>
        </Box>
      </Box> */}
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: 'calc(100% - 64px)'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default DashboardSidebar;
